var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "        \n    <div class=\"FV-region-navBar\"></div>\n        \n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPrevDocBtn : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showNextDocBtn : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"FV-docNavBtn FV-docPrev\" title=\"Previous\">\n            <i class=\"icon-left-big\"></i>\n        </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"FV-docNavBtn FV-docNext\" title=\"Next\">\n            <i class=\"icon-right-big\"></i>\n        </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showDocNavigation : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/template.hbs
 ** module id = 705
 ** module chunks = 0
 **/